(function () {
    'use strict';

    var data = window.recipeData;
    if (!data) return;

    var currentServings = data.baseServings;
    var MIN_SERVINGS = 1;
    var MAX_SERVINGS = 50;

    var valueEl = document.getElementById('servings-value');
    var displayEl = document.getElementById('servings-display');
    var decreaseBtn = document.getElementById('servings-decrease');
    var increaseBtn = document.getElementById('servings-increase');
    var ingredientItems = document.querySelectorAll('.ingredient-line[data-base-qty]');
    var bundleBtn = document.getElementById('add-bundle-to-cart');
    var bundleSummary = document.getElementById('bundle-summary');

    if (!valueEl || !decreaseBtn || !increaseBtn) return;

    decreaseBtn.addEventListener('click', function () {
      if (currentServings > MIN_SERVINGS) {
        currentServings--;
        update();
      }
    });

    increaseBtn.addEventListener('click', function () {
      if (currentServings < MAX_SERVINGS) {
        currentServings++;
        update();
      }
    });

    function update() {
      var multiplier = currentServings / data.baseServings;
      valueEl.textContent = currentServings;
      if (displayEl) displayEl.textContent = currentServings;

      ingredientItems.forEach(function (item) {
        // le righe senza quantita' (q.b., un mazzetto) restano come sono
        var baseQty = parseFloat(item.dataset.baseQty);
        var target = item.querySelector('.ingredient-line__amount');
        if (isNaN(baseQty) || !target) return;
        target.textContent = formatAmount(baseQty * multiplier, item.dataset.unit);
      });

      updateBundleSummary(multiplier);
      updateButtonState();
    }

    // Quantita' e unita' in un pezzo solo: 250 g, 1,5 kg, 1,1 litri, 3 spicchi.
    // Da 1000 g si passa ai kg e da 1000 ml ai litri, con la virgola e senza
    // zeri inutili.
    function formatAmount(qty, unit) {
      unit = unit || '';
      var wholeUnits = ['pezzi', 'uovo', 'uova', 'foglie', 'foglia', 'spicchi', 'spicchio', 'cucchiai', 'cucchiaio', 'pizzico'];
      if (wholeUnits.indexOf(unit) !== -1) {
        return Math.ceil(qty) + ' ' + unit;
      }
      if ((unit === 'g' || unit === 'grammi' || unit === 'ml') && qty >= 10) {
        qty = Math.round(qty / 5) * 5;
      }
      if ((unit === 'g' || unit === 'grammi') && qty >= 1000) {
        return decimale(qty / 1000, 2) + ' kg';
      }
      if (unit === 'ml' && qty >= 1000) {
        var litri = qty / 1000;
        return decimale(litri, 2) + (litri === 1 ? ' litro' : ' litri');
      }
      return (decimale(qty, 1) + ' ' + unit).trim();
    }

    function decimale(x, cifre) {
      var f = Math.pow(10, cifre);
      return String(Math.round(x * f) / f).replace('.', ',');
    }

    function updateBundleSummary(multiplier) {
      if (!bundleSummary) return;

      var items = [];
      var totalPrice = 0;

      data.ingredients.forEach(function (ing) {
        if (!ing.hasProduct || !ing.variantId) return;

        var neededQty = ing.qty * multiplier;
        var cartUnits = Math.ceil(neededQty / ing.productUnit);
        if (cartUnits < 1) cartUnits = 1;

        var linePrice = cartUnits * ing.productPrice;
        totalPrice += linePrice;

        items.push({
          name: ing.productTitle,
          units: cartUnits,
          price: linePrice
        });
      });

      if (items.length === 0) {
        bundleSummary.innerHTML = '<p>Nessun prodotto acquistabile collegato a questa ricetta.</p>';
        return;
      }

      var html = '<h3>Prodotti nel carrello:</h3><ul>';
      items.forEach(function (item) {
        html += '<li>' + item.name + ' x ' + item.units;
        if (item.price > 0) {
          html += ' — ' + (item.price / 100).toFixed(2).replace('.', ',') + ' €';
        }
        html += '</li>';
      });
      html += '</ul>';

      if (totalPrice > 0) {
        html += '<p class="recipe-bundle__total"><strong>Totale stimato: ' + (totalPrice / 100).toFixed(2).replace('.', ',') + ' €</strong></p>';
        html += '<p class="recipe-bundle__note">Aggiungiamo al carrello le confezioni intere che ti servono: quello che avanza resta nella tua dispensa.</p>';
      }

      bundleSummary.innerHTML = html;
    }

    // Sotto i 900px il pulsante sta dentro la barra fissa, con il contatore
    // delle porzioni a dieci pixel di distanza: scrivere "(7 persone)" sul
    // pulsante ripete il numero che si legge gia' li' accanto, e costringe la
    // scritta ad andare a capo. Su schermo largo il contatore e' lontano,
    // quindi il numero sul pulsante serve ancora.
    var stretto = window.matchMedia('(max-width: 900px)');

    function bundleLabel() {
      return stretto.matches
        ? 'Aggiungi al carrello'
        : 'Aggiungi ingredienti al carrello (' + currentServings + ' persone)';
    }

    function updateButtonState() {
      if (!bundleBtn) return;
      var hasPurchasableItems = data.ingredients.some(function (ing) {
        return ing.hasProduct && ing.variantId;
      });
      bundleBtn.disabled = !hasPurchasableItems;
      bundleBtn.textContent = hasPurchasableItems
        ? bundleLabel()
        : 'Nessun prodotto acquistabile';
    }

    // girando il telefono si passa da una scritta all'altra
    if (stretto.addEventListener) {
      stretto.addEventListener('change', updateButtonState);
    } else if (stretto.addListener) {
      stretto.addListener(updateButtonState);
    }

    if (bundleBtn) {
      bundleBtn.addEventListener('click', function () {
        var multiplier = currentServings / data.baseServings;
        var items = [];

        data.ingredients.forEach(function (ing) {
          if (!ing.hasProduct || !ing.variantId) return;

          var neededQty = ing.qty * multiplier;
          var cartUnits = Math.ceil(neededQty / ing.productUnit);
          if (cartUnits < 1) cartUnits = 1;

          var props = { 'Ricetta': data.title, '_ricetta_name': data.title, '_ricetta_handle': data.handle };
          if (ing.vendor) props['_produttore'] = ing.vendor;
          items.push({
            id: ing.variantId,
            quantity: cartUnits,
            properties: props
          });
        });

        if (items.length === 0) return;

        bundleBtn.disabled = true;
        bundleBtn.textContent = 'Aggiunta in corso...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Errore');
            return response.json();
          })
          .then(function () {
            bundleBtn.textContent = 'Aggiunto ✓';
            fetch('/cart.js')
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                document.dispatchEvent(new CustomEvent('cart:update', {
                  bubbles: true,
                  detail: {
                    resource: cart,
                    sourceId: 'recipe-bundle',
                    data: { itemCount: cart.item_count, source: 'recipe-bundle' }
                  }
                }));
              });
            setTimeout(function () {
              updateButtonState();
            }, 2000);
          })
          .catch(function () {
            bundleBtn.textContent = 'Errore — riprova';
            setTimeout(function () {
              updateButtonState();
            }, 2000);
          });
      });
    }

    update();
  })();